var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYandexclA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.4933 56 56 43.4933 56 28C56 12.5067 43.4933 0 28 0C12.5067 0 0 12.5067 0 28C0 43.4933 12.5067 56 28 56Z",
    fill: "#FC3F1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 43.8667H31.8266V16.4267H29.4C24.92 16.4267 22.5867 18.6667 22.5867 22.0267C22.5867 25.8533 24.2667 27.6267 27.6267 29.8667L30.4266 31.7333L22.2133 43.8667H16.24L23.52 33.1333C19.32 30.1467 17.08 27.2533 17.08 22.4C17.08 16.24 21.3733 12.1333 29.4 12.1333H37.3333V43.8667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexclA);
export default __webpack_public_path__ + "static/media/YandexclA.504d624e50c926fb9058f9065f7f7d24.svg";
export { ForwardRef as ReactComponent };